export interface Producto {
   denominacion: string;
   codProducto: string;
}

export const PRODUCTOS_DISPONIBLES_SIGNUP: Producto[] = [
   {denominacion: 'Tienda', codProducto: 'datatienda'}
];
